export default __webpack_public_path__ + "static/media/640_dummy2016-deko01-de-mobile.cb6d6ee2.png";